import {css} from '@emotion/react'
import styled from '@emotion/styled'

const HANDLE_BAR_HEIGHT = 24

export const Header = styled('div')(
  ({theme}) => css`
    background: ${theme.colors.background.neutral.c000};
    position: relative;
  `
)

export const HeaderWrapper = styled('div')(
  ({theme}) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: ${theme.layout.spacing.s500}px ${theme.layout.spacing.s900}px
      ${theme.layout.spacing.s200}px;
  `
)

export const HeaderContent = styled('div')(
  ({theme}) => css`
    touch-action: none;
    flex-grow: 1;
    text-align: center;
    ${theme.typography.text.titleM};
    margin: 0;
    color: ${theme.colors.content.neutral.c950};
  `
)

export const SubHeader = styled('div')(
  ({theme}) => css`
    flex-grow: 1;
    text-align: center;
    ${theme.typography.text.titleS};
    color: ${theme.colors.content.neutral.c950};
    padding: 0 ${theme.layout.spacing.s900}px ${theme.layout.spacing.s400}px;
  `
)

export const OverlayContent = styled('div')(
  ({contentPaddingBottom = 0}: {contentPaddingBottom?: number}) => css`
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    height: 100%;
    // needed to apply extra padding at the bottom for iOS gesture bar
    --safe-area-inset-bottom: env(safe-area-inset-bottom);
    padding-bottom: calc(
      ${contentPaddingBottom}px + var(--safe-area-inset-bottom)
    );
  `
)

export const Handle = styled('div')(
  ({theme}) => css`
    touch-action: none;
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: center;
    top: -${HANDLE_BAR_HEIGHT}px;
    height: ${HANDLE_BAR_HEIGHT}px;
    color: ${theme.colors.content.neutral.c000};
  `
)

export const FooterContent = styled('div')(() => css``)
